import Form from 'react-bootstrap/Form';
import { ReactTransliterate } from "react-transliterate";

import './css/components.css';
import "react-transliterate/dist/index.css";

const TransInput =({lang, text, setText, userResponse, hidden=false}) =>{
	console.log('1text', text);
	console.log('1userResponse', userResponse);
	return (		
		<>
			<ReactTransliterate
				lang ={lang}
				value ={text}
				defaultValue ={text}
				placeholder ={userResponse}
				onChange ={(e) => setText(e.target.value)}
				offsetX ={13}
				containerClassName ='editArea'
				renderComponent={
					(props) => <Form.Control  as="textarea" value={text} onChange={(e) => setText(e.target.value)} hidden={hidden}
											placeholder="Type your answer" defaultValue={userResponse} {...props} style={{fontSize:'90%', height:'8em'}} />
				}
				activeItemStyles={{backgroundColor:'rgb(0,123,255)', fontSize:'110%'}}
			/>
		</>
	);
}

export default TransInput;